import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoLocalePipesModule } from '@platform-frontend/transloco';
import { NgxMaskModule } from 'ngx-mask';
import { TemplateVariablesModule } from '../template-variables';
import { DateInputComponent } from './date-input/date-input.component';
import { UpcomingMonthSelectorComponent } from './upcoming-month-selector/upcoming-month-selector.component';

@NgModule({
  declarations: [DateInputComponent, UpcomingMonthSelectorComponent],
  imports: [CommonModule, FormsModule, TemplateVariablesModule, NgxMaskModule.forChild(), TranslocoModule, TranslocoLocalePipesModule],
  exports: [DateInputComponent, UpcomingMonthSelectorComponent]
})
export class DateSelectionModule {}
